import {
  BOOLEAN_CONDITIONS,
  DATE_CONDITIONS,
  FLAG_CONDITIONS,
  IPV4_CONDITIONS,
  NUMBER_CONDITIONS,
  STRING_CONDITIONS,
} from '@/Utils/filterConditions';

import {
  DEFAULT_INPUT_FOR_FILTER_VALUE,
  FILTER_MODEL_AGGREGATE_CNF_,
  FILTER_MODEL_CNF_,
  INPUT_FOR_FILTER_VALUE_WITH_SUGGESTIONS,
  INPUT_FOR_MULTIPLE_FILTER_VALUES,
  NO_INPUT_FOR_FILTER_VALUE,
} from '@/Utils/constants';

export const getFilterConditions = (colId, currFieldType) => {
  if (colId == null) {
    return [];
  }

  switch (currFieldType) {
    case 'Int64':
      return NUMBER_CONDITIONS;
    case 'UInt64':
      return NUMBER_CONDITIONS;
    case 'Float64':
      return NUMBER_CONDITIONS;
    case 'IPv4':
      return IPV4_CONDITIONS;
    case 'DateTime64':
      return DATE_CONDITIONS;
    case 'DateTime':
      return DATE_CONDITIONS;
    case 'Boolean':
      return BOOLEAN_CONDITIONS;
    case 'metadata_tag':
      return FLAG_CONDITIONS;
    default:
      return STRING_CONDITIONS;
  }
};

export const onColumnIdChange = (
  key,
  index,
  colId,
  currFieldType,
  filterType,
  columns,
  modelValue,
  filterModelElement,
  setIsSowBlock,
  onFilterChange,
  ifGroupIndex
) => {
  // eslint-disable-next-line
  const { filter, ...restOfFilterValues } = filterModelElement;
  if (modelValue !== filterModelElement.colId) {
    setIsSowBlock(false);
    onFilterChange(
      index,
      {
        ...restOfFilterValues,
        type: '',
        filterType,
        [key]: modelValue,
      },
      ifGroupIndex
    );
  }
};

export const onColumnFilterTypeChange = (
  key,
  index,
  modelValue,
  filterModelElement,
  onFilterChange,
  ifGroupIndex,
  activePanel = FILTER_MODEL_CNF_
) => {
  // eslint-disable-next-line
  const { filter, filterTo, type, isValidRegex, ...restOfFilterValues } = filterModelElement;

  if (modelValue !== filterModelElement.type) {
    const { filterType } = filterModelElement;
    if (
      getTypeOfValueInput(modelValue, activePanel) !==
      getTypeOfValueInput(filterModelElement.type, activePanel)
    ) {
      onFilterChange(
        index,
        {
          ...restOfFilterValues,
          filterType,
          [key]: modelValue,
        },
        ifGroupIndex
      );
    } else {
      onFilterChange(
        index,
        {
          ...restOfFilterValues,
          filter,
          filterType,
          [key]: modelValue,
        },
        ifGroupIndex
      );
    }
  }
};

const getTypeOfValueInput = (filterType, activePanel) => {
  if (filterType?.includes('Any') && activePanel === FILTER_MODEL_CNF_) {
    return INPUT_FOR_FILTER_VALUE_WITH_SUGGESTIONS;
  }

  if (filterType?.includes('Any') && activePanel === FILTER_MODEL_AGGREGATE_CNF_) {
    return INPUT_FOR_MULTIPLE_FILTER_VALUES;
  }

  if (filterType?.includes('Blank') || filterType?.includes('ternal')) {
    return NO_INPUT_FOR_FILTER_VALUE;
  }
  return DEFAULT_INPUT_FOR_FILTER_VALUE;
};

export const getColumnsMap = (columnDefs) => {
  const columnData = columnDefs;
  const columns = {};
  columnData.forEach((columnDef, i) => {
    const { field } = columnDef;
    columns[field] = {
      index: i,
      colId: field,
      name: columnDef.headerName,
      fieldType: columnDef.fieldType,
    };
  });
  columns['metadata_tag'] = {
    index: columnData.length,
    colId: 'metadata_tag',
    name: 'Row flag',
    fieldType: 'metadata_tag',
  };
  columns['*'] = {
    index: columnData.length + 1,
    colId: '*',
    name: 'Any Column',
    fieldType: 'text',
  };

  return columns;
};

export const flagOptions = [
  { value: '0', label: 'None' },
  { value: '1', label: 'Good' },
  { value: '2', label: 'Suspicious' },
  { value: '3', label: 'Bad' },
];

export const isValidIntersectFilter = (filter) => {
  return filter.type === 'intersect' && filter.otherHandle && filter.otherColumn;
};

export const isValidExceptFilter = (filter) => {
  return filter.type === 'except' && filter.otherHandle && filter.otherColumn;
};

export const generateFilterValue = (filter) => {
  if (
    filter.type === 'isBlank' ||
    filter.type === 'isNotBlank' ||
    filter.type === 'IPv4-IsBlank' ||
    filter.type === 'IPv4-IsNotBlank' ||
    filter.type === 'IPv4-Internal' ||
    filter.type === 'IPv4-External'
  ) {
    return true;
  } else if (filter.type === 'inRange') {
    return filter.filter && filter.filterTo;
  } else if (filter.isValidRegex === false) {
    return false;
  } else if (filter.type.includes('Any')) {
    return filter.filter?.length;
  } else return filter.filter;
};

export const handleDateModels = (dateModels, applyFilterModelFromState, hideModal) => {
  applyFilterModelFromState();
  hideModal();
};
